<script>
import { Line } from "vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/coreui/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";

export default {
  extends: Line,
  props: ["height", "type", "chartData"],
  data() {
    return {
      graphData: [],
      months: [],
      beencut: [],
      havebeencut: [],
      mightbecut: [],
      totalCut: [],
      totalCount: 0,
    };
  },
  watch: {
    type: function () {
      this.months = [];
      this.beencut = [];
      this.havebeencut = [];
      this.mightbecut = [];
      this.totalCut = [];
      this.chartData.reverse();
      for (var i = 0; i < this.type; i++) {
        this.months.push(
          this.chartData[i].month + " " + this.chartData[i].year
        );
        this.beencut.push(this.chartData[i].beencut);
        this.havebeencut.push(this.chartData[i].havebeencut);
        this.mightbecut.push(this.chartData[i].mightbecut);
        this.totalCut.push(this.chartData[i].total);
      }
      this.months.reverse();
      this.beencut.reverse();
      this.havebeencut.reverse();
      this.mightbecut.reverse();
      this.totalCut.reverse();
      this.chartData.reverse();
      this.totalCount = Math.max(...this.totalCut) + 20;

      this.makeGraph();
    },
  },
  mounted() {
    for (var i = 0; i < this.chartData.length; i++) {
      this.months.push(this.chartData[i].month + " " + this.chartData[i].year);
      this.beencut.push(this.chartData[i].beencut);
      this.havebeencut.push(this.chartData[i].havebeencut);
      this.mightbecut.push(this.chartData[i].mightbecut);
      this.totalCut.push(this.chartData[i].total);
    }
    this.totalCount = Math.max(...this.totalCut) + 20;
    this.makeGraph();
  },
  methods: {
    makeGraph() {
      this.renderChart(
        {
          labels: this.months,
          datasets: [
            {
              label: "Total Incidents",
              backgroundColor: hexToRgba("#20a8d8", 10),
              borderColor: "red",
              pointHoverBackgroundColor: "#fff",
              borderWidth: 2,
              data: this.totalCut,
            },
            {
              label: "Trees Been Cut",
              backgroundColor: "transparent",
              borderColor: "green",
              pointHoverBackgroundColor: "#fff",
              borderWidth: 2,
              data: this.beencut,
            },
            {
              label: "Trees Have Been Cut",
              backgroundColor: "transparent",
              borderColor: "blue",
              pointHoverBackgroundColor: "#fff",
              borderWidth: 1,
              borderDash: [8, 5],
              data: this.havebeencut,
            },
            {
              label: "Trees Might Be Cut",
              backgroundColor: "transparent",
              borderColor: "orange",
              pointHoverBackgroundColor: "#fff",
              borderWidth: 1,
              data: this.mightbecut,
            },
          ],
        },
        {
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: "index",
            position: "nearest",
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return {
                  backgroundColor:
                    chart.data.datasets[tooltipItem.datasetIndex].borderColor,
                };
              },
            },
          },
          maintainAspectRatio: false,
          legend: {
            display: true,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  drawOnChartArea: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: 5,
                  // stepSize: Math.ceil(this.totalCount / 5),
                  stepSize: 5,
                  max: this.totalCount,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 20,
              hoverRadius: 4,
              hoverBorderWidth: 3,
            },
          },
        }
      );
    },
  },
};
</script>
